import { render, staticRenderFns } from "./FormFile.vue?vue&type=template&id=0dd3d571&"
import script from "./FormFile.vue?vue&type=script&lang=js&"
export * from "./FormFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports